













































import SortHlasMixin from "../mixins/sort.hlas";
import Component from "vue-class-component";
import { Prop } from 'vue-property-decorator';
// @ts-ignore
import AlleleValidator from "@/services/allele.validator.js";

@Component({
    props: ["value", "disabled", "mask", "className", "isDonor", "haplotypes"]
})
export default class Hlas extends SortHlasMixin {
    @Prop()
    value!: any[];
    @Prop()
    haplotypes!: any;
    source: number = -1;

    get sorted() {
        if (this.value) {
            let sorted = this.value.slice();
            this.sortHlas(sorted);
            AlleleValidator.emptyValidation(sorted, this.source);
            return sorted;
        }

        return this.value;
    }

    get hasHaplotypesInfo() {
        return this.haplotypes &&
               this.haplotypes.firstAlleleColor.length > 0 &&
               this.haplotypes.secondAlleleColor.length > 0;
    }

    public getRowStyle(color) {
        let style = 'padding-left: 15px;';
        if (this.hasHaplotypesInfo) {
            style = `border-radius: 16px;padding: 10px 15px;border: 2px solid ${this.haplotypes[color]};`;
        }
        return style;
    }

    public markTouched(item: any, type: string) {
        const isFirst = type === 'first';
        const key = isFirst ? 'isFirstAllelleTouched' : 'isSecondAllelleTouched';
        this.value[item.sortValue - 1][key] = true;
        this.source = item.sortValue;
    }
}
